/**
 * https://forum.vuejs.org/t/how-to-use-the-same-ref-for-more-than-one-item/22481/10
 *
 * Add the same ref to multiple elements.
 *
 * @author LinusBorg, Simon Herteby
 * @example
 * <template>
 *   <div v-multi-ref:yourRefName>a</div>
 *   <li v-multi-ref:yourRefName>b</li>
 *   <a v-multi-ref:yourRefName>c</a>
 * </template>
 *
 * <script>
 *   mounted() {
 *     console.log(this.$refs.yourRefName) // [div, li, a]
 *   },
 * </script>
 */

function addRef(el, binding, vnode) {
  const ref = binding.arg
  const vm = vnode.context
  const thing = vnode.componentInstance || vnode.elm
  if (!vm.$refs.hasOwnProperty(ref)) {
    vm.$refs[ref] = []
  }
  const index = vm.$refs[ref].indexOf(thing)
  if (index == -1) {
    vnode.context.$refs[ref].push(thing)
  }
}

function removeRef(el, { arg: ref }, { context: vm }, vnode) {
  if (vm.$refs.hasOwnProperty(ref)) {
    const arr = vm.$refs[ref]
    const thing = vnode.componentInstance || vnode.elm
    const index = arr.indexOf(thing)
    if (index) {
      arr.splice(index, 1)
    }
  }
}

export default {
  bind: addRef,
  update: addRef,
  unbind: removeRef,
}
